import { useNavigate } from 'react-router';

import { toastService } from '@thefarmersfront/kitchen';

import { useQueryClient } from '@tanstack/react-query';

import { authDBService } from '~/services';

import { PATH } from '~/constants';

import { useAuthState, usePostUserLogout } from '../auth';

const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { updateIsAuthenticated } = useAuthState();

  const { postUserLogout } = usePostUserLogout();

  const logout = async () => {
    try {
      await postUserLogout();

      toastService.addToast({
        message: '로그아웃이 완료되었습니다.',
      });
    } catch (error) {
      console.error('로그아웃 요청에 실패했습니다.');
    } finally {
      await authDBService.logout();
      queryClient.clear();

      await updateIsAuthenticated();

      navigate(PATH.LOGIN, { replace: true });
    }
  };

  return { logout };
};

export default useLogout;
